import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, Container, Stack, Typography } from "@mui/material";
import { designTokens } from "../../../theme/designTokens";
import { visionContent } from "../../../theme/aboutContent";

const { colors, fonts, spacing } = designTokens;

const VisionSection = () => (
  <Box
    sx={{
      position: "relative",
      py: { xs: 6, md: 8 },
      overflow: "hidden",
      backgroundColor: colors.primary,
    }}
  >
    <Box
      component="img"
      src={visionContent.background}
      alt=""
      aria-hidden
      sx={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        zIndex: 0,
      }}
    />

    <Container maxWidth={spacing.containerMax} sx={{ position: "relative", zIndex: 1 }}>
      <Box sx={{ textAlign: "center", mb: { xs: 4, md: 5 } }}>
        <Typography
          sx={{
            fontWeight: fonts.weights.bold,
            fontSize: "1.25rem",
            lineHeight: "50px",
            color: colors.textPrimary,
            mb: 1,
          }}
        >
          {visionContent.label}
        </Typography>
        <Typography
          component="h2"
          sx={{
            fontWeight: fonts.weights.bold,
            fontSize: { xs: "1.75rem", md: "2.5rem" },
            lineHeight: "50px",
            color: colors.white,
            mb: 2,
            maxWidth: 763,
            mx: "auto",
          }}
        >
          {visionContent.title}
        </Typography>
        <Typography
          sx={{
            fontWeight: fonts.weights.medium,
            fontSize: { xs: "1rem", md: "1.25rem" },
            lineHeight: "30px",
            color: colors.white,
            maxWidth: 936,
            mx: "auto",
          }}
        >
          {visionContent.subtitle}
        </Typography>
      </Box>

      <Stack spacing={2} sx={{ maxWidth: 959, mx: "auto" }}>
        {visionContent.checklist.map((item) => (
          <Box
            key={item}
            sx={{
              backgroundColor: colors.white,
              borderRadius: "5px",
              boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
              minHeight: 73,
              display: "flex",
              alignItems: "center",
              gap: 2,
              px: { xs: 2, md: 3 },
              py: { xs: 1.5, md: 0 },
            }}
          >
            <CheckCircleOutlineIcon sx={{ color: colors.primary, fontSize: 35, flexShrink: 0 }} />
            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.25rem" },
                lineHeight: "50px",
                color: colors.textPrimary,
              }}
            >
              {item}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Container>
  </Box>
);

export default VisionSection;
